import { useContext, useEffect } from 'react'

import { useArcadeMigrationFeatureFlag } from '@cash-web/shared-data-access-arcade-migration'

import { ModalActionContext, ModalActionsElement } from './ModalActionContext'
import { IsInModalContext } from './ModalContext'
/**
 * Use this hook to override the actions of a modal.
 * @deprecated Use useArcadeModalActionOverride
 * @param actions - The actions to override the modal with.
 * @example
 * ```tsx
 *   useModalActionsOverride(
 *     <ModalActionHeader>
 *       <ModalCloseAction
 *         onClose={() => {
 *           // perform your close action
 *         }}
 *       />
 *       <ModalBackAction
 *         onBack={() => {
 *           // perform your back action
 *         }}
 *       />
 *     </ModalActionHeader>
 *   )
 * ```
 */
export const useModalActionsOverride = (actions: ModalActionsElement) => {
  const isInLegacyModal = useContext(IsInModalContext)
  const { setModalActions } = useContext(ModalActionContext)
  const isArcadeMigrationEnabled = useArcadeMigrationFeatureFlag('modal')

  useEffect(() => {
    if (isArcadeMigrationEnabled) {
      return
    } else if (!isInLegacyModal) {
      throw Error('Override is not within legacy modal')
    } else {
      setModalActions(actions)
    }
  }, [actions, isArcadeMigrationEnabled, isInLegacyModal, setModalActions])

  useEffect(() => {
    if (!isInLegacyModal) {
      return
    }
    return () => {
      // Clean up modal actions in a separate useEffect, so that it only runs on unmount
      setModalActions(undefined)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
